import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { ChevronDown } from "lucide-react";
import { guideFor } from "@/lib/scienceRubric";

function Criterion({ c, value, onChange, i }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-xl border border-[#EEEAF8] p-3" data-testid={`sci-criterion-${i}`}>
      <div className="mb-1 flex justify-between gap-2 text-sm"><span className="font-semibold text-[#1E1B2E]">{c.k}</span><span className="shrink-0 font-bold text-[#5B21B6]">{value}/10</span></div>
      <p className="mb-2 text-[11px] text-[#948EAB]">{c.wk}</p>
      <Slider value={[value]} min={0} max={10} step={1} onValueChange={(v) => onChange(v[0])} data-testid={`sci-slider-${i}`} />
      <button type="button" onClick={() => setOpen(!open)} className="mt-2 inline-flex items-center gap-1 text-xs font-bold text-[#4B2BB8]" data-testid={`sci-bands-toggle-${i}`}>
        Band descriptors <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-2 space-y-1.5">
          {c.bands.map(([b, t]) => {
            const [lo, hi] = b.split("–").map(Number);
            const on = value >= lo && value <= (hi ?? lo);
            return <div key={b} className={`rounded-lg p-2 text-xs leading-snug ${on ? "bg-[#F3F0FF] text-[#1E1B2E]" : "text-[#6B6488]"}`}><b>{b} marks:</b> {t}</div>;
          })}
        </div>
      )}
    </div>
  );
}

export function ScienceRubricPanel({ rubricDef, rubric, setRubric }) {
  const total = rubricDef.criteria.reduce((s, c) => s + (rubric[c.k] ?? 5), 0);
  return (
    <div data-testid="science-rubric">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-sm font-bold text-[#1E1B2E]">{rubricDef.name}</span>
        <span className="rounded-full ember-gradient px-3 py-1 text-sm font-extrabold text-white" data-testid="writing-total">{total}/50 · {guideFor(total)}</span>
      </div>
      <p className="mb-3 text-xs text-[#948EAB]">Choose the band that best fits, then place the mark within it. Upper mark = meets every descriptor and starts to show the next band; lower mark = most descriptors with one clear gap.</p>
      <div className="space-y-3">
        {rubricDef.criteria.map((c, i) => <Criterion key={c.k} c={c} i={i} value={rubric[c.k] ?? 5} onChange={(v) => setRubric({ ...rubric, [c.k]: v })} />)}
      </div>
      <div className="mt-4 rounded-xl bg-[#FFFBEB] p-3" data-testid="sci-marker-notes">
        <div className="mb-1 text-xs font-bold uppercase tracking-wide text-[#B45309]">Marker's notes</div>
        <ul className="list-disc space-y-1 pl-4 text-xs text-[#524B6B]">{rubricDef.notes.map((n) => <li key={n}>{n}</li>)}</ul>
      </div>
    </div>
  );
}
